//CONVERTS JSON TO STRING
/**
 *
 * @param value is the object you want to convert to string
 * @returns string
 */
export const stringifyJSON = (value: Record<string, any>): string =>
  JSON.stringify(value);

//PARSE STRING TO OBJECT
/**
 *
 * @param value is the string you want to convert to an object
 * @returns an object conversion of value
 */
export const parseJson = (value: string): Record<string, any> =>
  JSON.parse(value);

/**
 * @description parseJsonFromLocal finds item with key, if it exist it will return its parsed value, you have to pass the expected return type
 * @param key is the key used to store needed value on localStorage
 * @returns parsed value
 */
export const parseJsonFromLocal = <T>(key: string): T | undefined => {
  const storedString = localStorage.getItem(key);

  if (!storedString) return;
  return parseJson(storedString) as T;
};

/**
 * @description parseJsonFromSession finds item with key, if it exist it will return its parsed value, you have to pass the expected return type
 * @param key is the key used to store needed value on sessionStorage
 * @returns parsed value
 */
export const parseJsonFromSession = <T>(key: string): T | undefined => {
  const storedString = sessionStorage.getItem(key);

  if (!storedString) return;
  return parseJson(storedString) as T;
};

export const saveToSession = (key: string, value: Record<string, any>) => {
  if (!key || !value) return;
  const stringValue = stringifyJSON(value);
  sessionStorage.setItem(key, stringValue);
};

export const removeFromSession = (key: string) => {
  if (!key) return;
  sessionStorage.removeItem(key);
};
